import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';
import { KEYS } from '../../types';
@Component({
	selector: 'app-date-duration',
	templateUrl: './date-duration.component.html',
	styleUrls: ['./date-duration.component.css']
})
export class DateDurationComponent implements OnInit {
	@Input() formElement: any = {};
	@Input() label: string;
	@Input() required = false;
	@Input() name: string;
	@Input() placeholder: string;
	@Input() formValue?: FormGroup;
	@Input() fromDate: any = '';
	@Input() toDate: any = '';
	@Input() disabled = false;
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	labelClass: any;
	show = true;
	inputClass: any = ['input-group input-height'];
	rowClass: any;
	@Input()
	set value(date: any) {
		this.fromDate = (date && Helpers.toCalendarDate(date.fromDate)) || null;
		this.fromDateChange.emit(this.fromDate);
		this.toDate = (date && Helpers.toCalendarDate(date.toDate)) || null;
		this.toDateChange.emit(this.toDate);
	}
	get value() {
		return {
			fromDate: this.fromDate && Helpers.toDateFromCalendar(this.fromDate),
			toDate: this.toDate && Helpers.toDateFromCalendar(this.toDate),
		}
	}
	@Output() valueChange = new EventEmitter();
	@Output() fromDateChange = new EventEmitter();
	@Output() toDateChange = new EventEmitter();
	@Output()
	change = new EventEmitter<{
		name: string;
		value: any;
	}>();
	@Output()
	blur = new EventEmitter<{
		name: string;
		value: any;
	}>();
	constructor(private scriptLoaderService: ScriptLoaderService) { }

	set inputValue(value) {
		if (this.formValue) {
			this.formValue.setValue(this._value);
		}
	}

	// private _formatView() {
	// 	this.labelClass = ['col-form-label field-label'];
	// 	this.inputClass = ['input-group input-height'];
	// 	let derivedLabelClass = [];
	// 	let derivedInputClass = [];
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	derivedLabelClass = [`col-md-${labelDiv}`, 'right-text'];
	// 	derivedInputClass = [`col-md-${inputDiv}`];
	// 	if (this.formElement.row) {
	// 		this.rowClass = ['row'];
	// 		// this.labelClass.push('col-2', 'right-text');
	// 		// this.inputClass.push('col-5');
	// 	} else {
	// 		this.labelClass.push('col-md-12');
	// 		this.inputClass.push('col-md-6');
	// 	}
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// }

	private _formatView() {
		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(6)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
	}

	ngOnInit() {
		if (this.formElement.elements[1].hideEndDate === false) {
			this.show = false
		}

		if (this.formElement && this.formElement.onInit) {
			this.formElement.onInit();
		}
		if (this.formElement || Object.keys[this.formElement] !== 0) {
			this.disabled = this.formElement.disabled || false;
			this._formatView();
		}
		if (this.formValue) {
			console.log(this.formValue);
			this.formValue.valueChanges.subscribe(data => {
				if (data) {
					data.fromDate = data.fromDate || null;
					data.toDate = data.toDate || null;
				}
				this.onFormValueChange(data);
			});
		}
		this.fromDate = this.fromDate || this.formElement.elements[0].value;
		this.toDate = this.toDate || this.formElement.elements[1].value;
		if (this.fromDate || this.toDate) {
			this.onChange('all');
		}
		this.scriptLoaderService.addScriptTagToElementDOM(
			FORM_STYLE_CONFIG.datePicker[FORM_STYLE_CONFIG.datePicker.default]
		);
	}

	isDisabled() {
		return (this.disabled || this.formElement.readOnly) ? '' : null;
	}

	onChange(type) {
		this.makeDirty();
		this.inputValue = this._value;
		switch (type) {
			case 'fromDate': {
				this.fromDateChange.emit(this.fromDate);
				if (this.formElement.fromDateChanged) {
					this.formElement.fromDateChanged()
				}
				break;
			}
			case 'toDate': {
				this.toDateChange.emit(this.toDate);
				if (this.formElement.toDateChanged) {
					this.formElement.toDateChanged()
				}
				break;
			}
		}
		// this.fromDateChange.emit(this.fromDate);
		// this.toDateChange.emit(this.toDate);
		this.valueChange.emit(this._value);
		this.change.emit({
			name: this.formElement.name,
			value: this._value
		});
	}

	makeDirty() {
		if (this.formValue) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
	}
	onFormValueChange(val) {
		if (val && (val.fromDate || val.toDate)) {
			if (!(this.value === val)) {
				this.value = val;
				this.formValue.markAsPristine();
			}
			if (this.formElement.markAsUntouched) {
				this.formValue.markAsPristine();
				this.formValue.markAsUntouched();
				this.formElement.markAsUntouched = false;
			}
		} else {
			this.fromDate = '';
			this.toDate = '';
		}
	}
	get _value() {
		return {
			// fromDate: this.fromDate,
			// toDate: this.toDate,
			fromDate: this.fromDate ? Helpers.toDateFromCalendar(this.fromDate) : null,
			toDate: this.toDate ? Helpers.toDateFromCalendar(this.toDate) : null
		};
	}

	discardKey(event) {
		const key: string = event.key;
		const allowedKeys: any = [KEYS.TAB];
		if (allowedKeys.indexOf(key) >= 0) {
			return;
		}
		event.preventDefault();
	}

	focus(id) {
		Helpers.focuseOn(id);
	}
}
